import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { interval, Observable } from 'rxjs';
import { GenericService } from 'src/app/services/generic.service';
import { WebsocketService } from 'src/app/services/websocket.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {
  userId = 0
  userName = ""
  userList: any;
  toUserId = 0
  toUserName = ""
  conversation = ""
  searchUserFilter= ""
  userConversationList: any= []
  singleUserChart: any= []
  conversationObj: any= []
  userIdNameList:any= []
  conversationId = ""
  private timer: any;
  TicketTaskdata: any = [];
  TicketData: any = [];
  task:any = []
  type = ''
  cid :any

  constructor(private wb :WebsocketService,private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { 

  }

  ngOnInit(): void {
    // this.wb.socketConnection()
    this.userId = Number(sessionStorage.getItem('userId'));
    this.cid = sessionStorage.getItem('cid')

    this.getallUsers();
    this.getConversationListByUserId(sessionStorage.getItem('userId'))
  }

  getallUsers(){
    this.generic_service.getUsers().subscribe(
      (response:any)=>{
        let ul = [];
        for(let i=0; i<response.response.length; i++) {
          if(response.response[i].userId != Number(sessionStorage.getItem('userId'))){
            ul.push(response.response[i])
          }
        }
        this.userList = ul;
      }
    )
  }

  selectUser(userName:any,userId:any){
    this.toUserId = userId;
    this.toUserName = userName;
    this.conversation = ''
  }

  insertConversation(toUserName: any,toUserId: any){
    let body =  {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": 0,
      "conversationType": "ONE_TO_ONE",
      "ticketTaskId": 0,
      "userIdList": [
        Number(toUserId), Number(sessionStorage.getItem('userId'))
      ],

      "remarks": "",
      "cid": this.cid

    }
    console.log(body)
    this.generic_service.insertConversation(body).subscribe(
      (response:any)=> {
        console.log(response)
        this.getConversationListByUserId(sessionStorage.getItem('userId'))
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  userDropDown(){
    let list = document.getElementById('user-drop-down')
    if(list?.classList.contains('dropdown-data-show')){
      list.classList.remove('dropdown-data-show')
    }else{
      list?.classList.add('dropdown-data-show')
    }
  }

  chartSubmit(){
    let body = {
      "conversation": String(this.conversation),
      "conversationDate": 0,
      "userId": Number(sessionStorage.getItem('userId'))
    }

    this.generic_service.addConversationByConversationId(this.conversationId,body).subscribe(
      (response:any)=> {
        console.log(response),
        this.conversation = ''
        this.getSingleConversation(this.conversationId,this.toUserName,this.type)
        this.wb.socketC(this.type,sessionStorage.getItem('userEmail'),this.conversation,this.conversation)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }
  
  getConversationListByUserId(userId:any){
    this.generic_service.getConversationByUserId(userId).subscribe(
      (response:any)=>{
        for(var i=0; i<response.response.length; i++){
          console.log(response.response[i].userIdNameList);
          let obj = response.response[i].userIdNameList;
          let arr1 = []
          let arr2 = []

          for(var j=0;j<obj.length;j++){
            if(obj[j].userid == userId){
              arr1.push(obj[j])
            }else{
              arr2.push(obj[j])
            }
          }
          let arr3 = arr1.concat(arr2)
          response.response[i].userIdNameList = arr3;
        }

        this.userConversationList = response.response;
        console.log(response)
        console.log(this.userConversationList)

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getSingleConversation(conversationId:any,name:any,type:any){
    this.type = type
    this.toUserName = name
    if(this.conversationId != conversationId){
      this.conversation = ""
    }
    this.conversationId = conversationId

    this.generic_service.getConversationById(conversationId).subscribe(
      (response:any)=>{
        console.log(response)
        console.log(response.response.userIdNameList);
        let obj = response.response.userIdNameList;
        let arr1 = []
        let arr2 = []

        for(var j=0;j<obj.length;j++){
          if(obj[j].userid == this.userId){
            arr1.push(obj[j])
          }else{
            arr2.push(obj[j])
          }
        }
        let arr3 = arr1.concat(arr2)
        response.response.userIdNameList = arr3;
        console.log(response.response.userIdNameList);

        this.singleUserChart = []
        this.singleUserChart.push(response.response)
        this.userIdNameList = response.response.userIdNameList
        this.conversationObj = response.response.conversationObj
      },
      (error:any)=>{
        console.log(error)
      }
    )
    // setTimeout(() => {
    //   this.getSingleConversation(conversationId);
    // }, 5000);
    
    // interval(5000).subscribe(x => {
    //   this.getSingleConversation(conversationId);
    // });
  }
  @ViewChild('scrollMe') myScrollContainer!: ElementRef;

  ngAfterViewChecked() {        
      this.scrollToBottom();
  } 
  scrollToBottom(): void {
    try {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch(err) { }                 
  }

  addc(i: any){
    let list = document.getElementById(i)
    if(list?.classList.contains('dropdown-data-show')){
      list.classList.remove('dropdown-data-show')
    }else{
      list?.classList.add('dropdown-data-show')
    }
  }

  getTicketTaskByID(id:any){
    console.log(id)
    this.TicketData = []
    this.generic_service.getTicketTaskByID(id).subscribe(
      (res:any)=>{
        this.TicketData.push(res.response.ticket);
        this.TicketTaskdata = res.response.taskList;
        console.log(res);
      }
    )
  }

  getSingleTask(id:any){
    console.log(id)
    this.generic_service.getSingleTask(id).subscribe(
      (res:any)=>{
        this.task = [];
        console.log(res);
        this.task.push(res.response);
      }
    )
  }

}

